module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "structure-next",
    attrs: {
      "id": "calibre_pb_7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("Also by Irene O’Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Risking the Rapids: How My Wilderness Adventure Healed My")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Childhood")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Fat Girl: One Woman")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("’s Way")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Out")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Fulcrum: Sele")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("cted")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Poems")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Women on F")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("ire (play)")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("For Children")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("May")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("be My")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Baby")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The Scrubbly Bubbl")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("y Car")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Wash")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Forest, What Would")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" You Like?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_8"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-453b356f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/GladtoBeHuman_split_003.vue
// module id = 69
// module chunks = 0